// Shared widget types. Every widget renders into the MatterDashboard grid
// based on a `WidgetConfig` from `template.ui.widgets[]` and reads its
// per-matter data from `matter.workspace` (schemaless bag, see Matter type).

import type { WidgetConfig } from "../../../hooks/usePracticeAreaTemplate";
import type { Client, Matter, PracticeAreaTemplate } from "./shared";

export type { WidgetConfig };

export interface WidgetProps {
  config: WidgetConfig;
  matter: Matter;
  client?: Client | null;
  template?: PracticeAreaTemplate | null;
}

/** Narrow `matter.workspace[key]` to T at the call site. */
export function pick<T>(bag: Record<string, unknown> | undefined, key: string): T | undefined {
  if (!bag) return undefined;
  const v = bag[key];
  return v as T | undefined;
}

/** Resolve `"matter.foo.bar"` against the matter object. Returns unknown. */
export function resolveSource(matter: Matter, source?: string): unknown {
  if (!source) return undefined;
  // Strip a leading `matter.` if present.
  const path = source.replace(/^matter\./, "");
  const parts = path.split(".");
  let cur: unknown = matter;
  // Try matter top-level first, then matter.workspace.
  for (let i = 0; i < parts.length; i++) {
    if (cur && typeof cur === "object") {
      cur = (cur as Record<string, unknown>)[parts[i]!];
    } else {
      cur = undefined;
      break;
    }
  }
  if (cur != null) return cur;
  // Fall back to workspace bag.
  let bag: unknown = matter.workspace;
  for (const p of parts) {
    if (bag && typeof bag === "object") {
      bag = (bag as Record<string, unknown>)[p];
    } else {
      bag = undefined;
      break;
    }
  }
  return bag;
}
